import { Box } from "@mui/material";
import LogonSidebar from "../../components/LogonSidebar";
import Form from "./Form";
import classes from "../../styles/LogonStyle";

const Login = () => {
	return (
		<Box component="section" sx={classes.Logon}>
			<Form />
			<LogonSidebar />
		</Box>
	);
};

export default Login;
